import CustomPageCompose from "../helpers/CustomPageCompose";
import withRouteProps from '@xem/entity-client-react/components/withRouteProps';
import PageView from "../components/CustomPageView";
export default CustomPageCompose(({ start_time })=>{
	if(isTrue('DEBUG')){
		let end_time = (new Date()).getTime(), run_time = end_time - start_time;
		console.warn('####### PAGE', {start_time, end_time, run_time})
	}
}, [ withRouteProps ], [], true)(PageView);